exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.diy-imageSingle img{ max-width: 100%;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/page/page/diy/model/ImageSingle.vue"],"names":[],"mappings":";AACA,sBAAsB,gBAAgB;CACrC","file":"ImageSingle.vue","sourcesContent":["\n.diy-imageSingle img{ max-width: 100%;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b342df48","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/page/page/diy/model/ImageSingle.vue
// module id = GH/3
// module chunks = 0